












































import Vue, {PropType} from 'vue';
import {Contract} from '@/types';

type Data = {
  dialog: boolean,
  error: Error | null
};

export default Vue.extend({
  props: {
    contract: {
      type: Object as PropType<Contract>,
      required: true
    },
    rejected_at: {
      type: String
    }
  },
  data(): Data {
    return {
      dialog: false,
      error: null
    };
  },
  computed: {
    contract_id(): number {
      return this.$props.contract.id;
    },
    buttonColor(): string {
      return 'error lighten-2';
    }
  },
  methods: {
    save() {
      const {contract_id} = this;
      this.startSaving();
      this.$store.api.rejectOrder({
        contract_id
      }).then(() => {
        this.$store.change();
        this.dialog = false;
      }).catch(this.setError).then(this.stopSaving);
    }
  }
});
